<template>
  <div class="bbp-list-requests">
    <ListOfRequestsHeader :totalAmount="totalValue" />
    <div class="bbp-list-requests-header">
      <BBPTabsType2
        :tabs="tabs"
        :activeTab.sync="activeTab"
        minmax="220px, 240px"
      />
      <BBPSearch @change="getSearchValue"/>
      <button
        class="bbp-button bbp-list-requests-header__button"
        @click.stop="openRequestForm = true"
      >
        add request
      </button>
    </div>
    <div>
      <BBPTable
        :columns="columns"
        :rows="requestsList"
        :no-data-text="noDataText"
        :limit="defLimit"
        :page="currentPage"
        :no-data="noData"
        :max-height="'calc(100vh - 250px)'"
        @update="preUpdateRequest"
        @delete="deleteRequest"
        @edit="openEditRequest"
        @filter="setFilter"
      />
      <BBPPagination v-show="requestsList.length > 0"
                     :data="fullInfo"
                     :getQuery="getRequests"
                     :limit="defLimit"
                     :sticky="true"
                     class="bbp-pagination"/>
    </div>
    <div class="bbp-list-requests-completed">
      <ListOfRequestWithStatus
        @loader="setLoader"
        class="bbp-list-requests-completed__item"
        :status="1"
        :activeTab="activeTab"
      />
      <ListOfRequestWithStatus
        @loader="setLoader"
        class="bbp-list-requests-completed__item"
        :status="2"
        :activeTab="activeTab"
      />
    </div>
    <transition name="bbp-fade">
      <BBPModalWindow
        v-if="openRequestForm"
        @close="closeRequestForm"
      >
        <RequestForm
          :request="editableRequest"
          :activeTab="activeTab"
          @updateTotalValue="updateTotalValue"
          @close="closeRequestForm"
          @loader="setLoader"
        />
      </BBPModalWindow>
    </transition>
    <transition name="bbp-fade" appear>
      <BBPLoader v-if="loaderRun"></BBPLoader>
    </transition>
    <transition name="bbp-fade">
      <BBPModalWindow v-if="openStatusModal" @close="closeStatusModal">
        <RequestChangeStatus :statusId="openStatusModal"
                             title="State the reason why project was not taken forward:"
                             @save="saveStatusRequest"
                             @close="closeStatusModal"
                             :options="declinedOptions"/>
      </BBPModalWindow>
    </transition>
  </div>
</template>

<script>
import {get, set, findIndex, cloneDeep, orderBy, find} from 'lodash'
import BBPTable from '@/components/Main/BBPTable/BBPTable'
import BBPSearch from '@/components/Main/InputFields/BBPSearch/BBPSearch'
import BBPModalWindow from '@/components/Main/BBPModalWindow/BBPModalWindow'
import RequestForm from '@/components/Requests/RequestForm/RequestForm'
import BBPLoader from '@/components/Main/BBPLoader/BBPLoader'
import BBPPagination from '@/components/Main/BBPPagination/BBPPagination'
import RequestApi from '@/api/Requests/api'
import UserApi from '@/api/Users/api'
import ListOfRequestTagsApi from '@/api/ListOfRequestTags/api'
import listOfRequestsColumns from '@/constants/TablesSettings/listOfRequestsColumns'
import setRequestBody from '@/mixin/setRequestBody'
import ListOfRequestWithStatus from '@/components/Requests/ListOfRequests/ListOfRequestWithStatus'
import {DELAYED, IN_PROGRESS} from '@/constants/requestStatuses'
import RequestChangeStatus from '@/components/Requests/RequestChangeStatus/RequestChangeStatus'
import {DECLINE_OPTIONS} from '@/constants/declineOptions'
import ListOfRequestsHeader from '@/components/Requests/ListOfRequests/ListOfRequestsHeader'
import BBPTabsType2 from '@/components/Main/BBPTabsType2/BBPTabsType2'
import { REQUESTS_TABS, BC_REQUEST_TAB_ID } from '@/constants/tabs/requestsTabs'

export default {
  name: 'ListOfRequests',
  mixins: [setRequestBody],
  components: {
    BBPTabsType2,
    ListOfRequestsHeader,
    ListOfRequestWithStatus,
    RequestForm,
    BBPModalWindow,
    BBPSearch,
    BBPLoader,
    BBPPagination,
    BBPTable,
    RequestChangeStatus
  },
  data () {
    return {
      loaderRun: false,
      searchWords: '',
      openRequestForm: false,
      editableRequest: {},
      currentPage: 1,
      defLimit: 25,
      fullInfo: {},
      noData: false,
      openStatusModal: false,
      noDataText: 'Sorry, no requests found.',
      declinedOptions: DECLINE_OPTIONS,
      totalValue: 0,
      filterByHashtag: [],
      filter: {
        projectManager: '',
        businessConsultant: ''
      },
      activeTab: BC_REQUEST_TAB_ID,
      tabs: REQUESTS_TABS
    }
  },
  computed: {
    columns () {
      const columns = listOfRequestsColumns.map(col => col)
      return columns.filter(col => {
        return col.prop !== 'dateEnd'
      })
    },
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    },
    requestsList: {
      get () {
        return this.$store.getters.requestsList
      },
      set (data) {
        this.$store.dispatch('setRequestsList', data)
      }
    },
    requestsListDeclined: {
      get () {
        return this.$store.getters.requestsListDeclined
      },
      set (data) {
        this.$store.dispatch('setRequestsListDeclined', data)
      }
    },
    requestsListForward: {
      get () {
        return this.$store.getters.requestsListForward
      },
      set (data) {
        this.$store.dispatch('setRequestsListForward', data)
      }
    },
    listOfRequestTags: {
      get () {
        return this.$store.getters.listOfRequestTags
      },
      set (data) {
        this.$store.dispatch('setListOfRequestTags', data)
      }
    }
  },
  methods: {
    updateColumns () {
      const manager = this.columns.find((el) => el.isType)
      const isBC = this.activeTab === BC_REQUEST_TAB_ID
      manager.title = isBC ? 'BC' : 'PM'
      manager.display = `${isBC ? 'businessConsultant' : 'projectManager'}.image.path`
      manager.popup = `${isBC ? 'businessConsultant' : 'projectManager'}.username`
      manager.prop = isBC ? 'businessConsultant' : 'projectManager'
    },
    getSearchValue (val) {
      this.searchWords = val
      this.getRequests({})
    },
    closeRequestForm () {
      this.openRequestForm = false
      this.editableRequest = {}
    },
    setLoader (val) {
      this.loaderRun = val
    },
    updateTotalValue (index, data) {
      if (data) {
        const { amount = 0 } = data
        if (index === -1) {
          this.totalValue = this.totalValue + amount
        } else {
          const item = this.requestsList[index]
          const { amount: oldAmount = 0 } = item
          this.totalValue = this.totalValue + amount - oldAmount
        }
        return
      }
      const item = this.requestsList[index]
      const { amount = 0 } = item
      this.totalValue = this.totalValue - amount
    },
    deleteRequest ({row}) {
      const requestId = get(row, 'id', '')
      if (!requestId) return
      const index = findIndex(this.requestsList, {id: requestId})
      this.updateTotalValue(index)
      const deletedRequest = index !== -1 ? this.requestsList.splice(index, 1) : []
      RequestApi.deleteRequest(requestId)
        .then(resp => {
          return resp
        })
        .catch(err => {
          if (index !== -1) this.requestsList.splice(index, 0, ...deletedRequest)
          console.error(err)
        })
    },
    openEditRequest ({row}) {
      this.openRequestForm = true
      this.editableRequest = cloneDeep(row)
    },
    filterByTag (newVal) {
      const item = `tags[]=${[newVal]}`
      const currentIndex = this.filterByHashtag.findIndex((el) => el === item)
      if (currentIndex === -1) {
        this.filterByHashtag.push(item)
      } else {
        this.filterByHashtag.splice(currentIndex, 1)
      }
      this.currentPage = 1
      this.getRequests({})
    },
    filterByPmBc (prop, newVal) {
      this.filter[prop] = this.filter[prop] ? '' : newVal
      this.currentPage = 1
      this.getRequests({})
    },
    setFilter (item) {
      const { newVal, column = {} } = item
      const { prop } = column
      if (prop === 'name') return this.filterByTag(newVal)
      this.filterByPmBc(prop, newVal)
    },
    closeStatusModal () {
      this.openStatusModal = false
      const editableRow = find(this.requestsList, {id: this.editableRequest.id}) || {}
      editableRow.status = this.editableRequest.status
      this.editableRequest = {}
    },
    saveStatusRequest (comment) {
      if (comment) set(this.editableRequest, 'comments', comment.map(({text}) => text))
      set(this.editableRequest, 'status', this.openStatusModal)
      this.updateRequest({row: this.editableRequest})
      this.closeStatusModal()
    },
    preUpdateRequest ({row, column, value}) {
      if (column.type === 'menu') {
        this.editableRequest = cloneDeep(row)
        setTimeout(() => { this.openStatusModal = value }, 250)
      } else {
        this.closeStatusModal()
        this.updateRequest({row})
      }
    },
    updateRequest ({row}) {
      const request = this.setRequestBody(row)
      const index = findIndex(this.requestsList, {id: row.id})
      this.updateTotalValue(index)
      RequestApi.editRequest(request)
        .then(({data}) => {
          const { status } = data
          const isDeclined = status === DELAYED.id
          const isForward = status === IN_PROGRESS.id
          if (index !== -1) this.requestsList.splice(index, 1)
          if (!status) {
            this.requestsList.push(data)
            this.requestsList = orderBy(this.requestsList, ['dateStart'], ['desc'])
          } else if (isDeclined) {
            this.requestsListDeclined.push(data)
            this.requestsListDeclined = orderBy(this.requestsListDeclined, ['dateStart'], ['desc'])
          } else if (isForward) {
            this.requestsListForward.push(data)
            this.requestsListForward = orderBy(this.requestsListForward, ['dateStart'], ['desc'])
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getRequests ({page}) {
      this.loaderRun = true
      this.currentPage = page || this.currentPage
      const query = {
        limit: this.defLimit,
        page: this.currentPage,
        sort: 'dateStart&sort[]=-1',
        status: '0',
        search: this.searchWords,
        tags: this.filterByHashtag,
        requestType: this.activeTab,
        ...this.filter
      }
      RequestApi.getRequests(query)
        .then(({data}) => {
          const { totalDocs = 0, requests = [], totalValue = 0 } = data
          this.getUsersListSelect()
          this.noData = !totalDocs
          this.fullInfo = data
          this.requestsList = requests
          this.totalValue = totalValue
        })
        .catch(err => {
          this.loaderRun = false
          this.noData = true
          console.error(err)
        })
    },
    async getUsersListSelect () {
      if (this.usersListProjects.length) {
        this.loaderRun = false
        return
      }
      try {
        const { data } = await UserApi.getUsersListSelect({})
        this.usersListProjects = data
        this.loaderRun = false
      } catch (err) {
        this.loaderRun = false
        console.error(err)
      }
    },
    async getTags () {
      try {
        const { data } = await ListOfRequestTagsApi.getTags()
        this.listOfRequestTags = data
      } catch (err) {
        console.error(err)
      }
    },
    resetFilter () {
      this.filterByHashtag = []
      this.filter = {
        projectManager: '',
        businessConsultant: ''
      }
    }
  },
  watch: {
    activeTab () {
      this.resetFilter()
      this.updateColumns()
      this.getRequests({})
    }
  },
  beforeMount () {
    this.updateColumns()
    this.getRequests({})
    if (!this.listOfRequestTags.length) this.getTags()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-list-requests {
    @include global-font;
    height: auto;
    max-height: calc(100%);

    &-header {
      display: grid;
      grid-template-columns: 1fr minmax(150px, 578px) auto;
      grid-gap: 50px;
      justify-content: space-between;
      align-items: center;
      margin: 14px auto 0;

      &__button {
        height: 42px;
        white-space: nowrap;
      }
    }

    &-completed {
      position: relative;
      transition: 0.3s;

      &__item {
        margin-top: 30px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Requests/ListOfRequests/ListOfRequests.vue